// extracted by mini-css-extract-plugin
export default {"tag":"IsActiveSwitch_tag__QpE7s"};